'use client';
import { Toaster } from 'sonner';

export default function ToasterWrapper() {
  return (
    <Toaster
      position="bottom-left"
      richColors
      toastOptions={{
        style: {
          fontFamily: "'Noto Kufi Arabic', 'IBM Plex Sans Arabic', sans-serif",
          fontSize: '14px',
          direction: 'rtl',
        },
      }}
    />
  );
}
